// extracted by mini-css-extract-plugin
module.exports = {"footer":"style-module--footer--1B_dT","copy":"style-module--copy--21GMd","legal":"style-module--legal--2kbIQ","last":"style-module--last--1-T8Z","link":"style-module--link--3ulCI"};